import { ThemeOptions } from "@mui/material/styles/createTheme";
import { PatientColors } from "@kahunmedical/common-configuration/dist/configuration/theme";

export const createCommonTheme = (
  mainLayoutClassName: string,
  fontFamily: string,
  themeOptions: ThemeOptions = {},
  colors = new PatientColors(),
) => {
  const { components, ...restOfThemeOptions } = themeOptions || {
    components: {},
  };
  const {
    MuiScopedCssBaseline: muiScopedCssBaselineOverrides,
    ...restOfOverrides
  } = components || {
    MuiScopedCssBaseline: {},
  };

  const {
    styleOverrides: scopedStyleOverrides,
    ...restOfMuiScoped
  } = muiScopedCssBaselineOverrides || { styleOverrides: {} };

  const {
    root: scopedRootStyleOverrides,
    ...restOfMuiScopedOverrides
  } = scopedStyleOverrides || { root: {} };

  const retVal = {
    typography: {
      body1: {
        [`.${mainLayoutClassName} &`]: {
          fontFamily: fontFamily,
        },
      },
      // fontFamily: settings.bodyFontFamily || fontFamily,
      caption: {
        [`.${mainLayoutClassName} &`]: {
          fontFamily: fontFamily,
        },
      },
      button: {
        [`.${mainLayoutClassName} &`]: {
          fontFamily: fontFamily,
        },
      },
      ...(themeOptions?.typography || {}),
    },
    components: {
      MuiScopedCssBaseline: {
        styleOverrides: {
          root: {
            fontFamily: fontFamily,
            fontSize: "15px",
            fontWeight: 300,
            lineHeight: "1.15",
            ...colors,
            ...(scopedRootStyleOverrides || {}),
          },
          ...restOfMuiScopedOverrides,
        },
        ...(restOfMuiScoped || {}),
      },
      ...(restOfOverrides || {}),
    },
    ...(restOfThemeOptions || {}),
  };

  console.log("creating theme:", retVal);

  return retVal;
};
